<i18n src="@/i18n/enums/support_ticket_status.json"></i18n>
<template>
	<TabFilter v-if="page.meta" :list="filterableStatus" :totals="totalPerStatus" :selected="selected" selected-key="id" @selected="handleSelectStatus"/>
</template>

<script>
import _Filter from "lodash/filter.js"
import {options as SupportTicketStatusOptions} from "@/enums/support_ticket_status.js"
import {translateEnum} from "@/helpers.js"

import SupportTicketStatus from "@/enums/support_ticket_status.js"
import TabFilter from "@/components/TabFilter.vue"
import ShipmentCustomFilterButton from "@/domain/shipments/ShipmentCustomFilterButton.vue"

export default {
    name: "FilterStatusBar",
    props: {
        page: {
            type: [Object, Array],
            required: true
        },
        selected: {
            type: [Number, String],
            default: null
        },
        debug: Boolean
    },
    components: {
        ShipmentCustomFilterButton,
        TabFilter
    },
    computed: {
        /**
         * List of status count
         * @returns {*|*[]}
         */
        totalPerStatus() {
            return this.page?.meta?.total_per_status ?? []
        },
        /**
         * List of filterable status list (translated)
         * @returns {[{label: VueI18n.TranslateResult, class: string, shipment_status: null},...*]}
         */
        filterableStatus() {
            // const list = _Filter(SupportTicketStatus, {'filter_tab': true});

            // `text` é a chave usada pelo TabFilter para achar o total em `total_per_status`
            return [
                {
                    id: -1,
                    text: 'mine',
                    label: this.$t('Meus tickets'),
                    class: 'bg-turquoise text-white'
                },
                {
                    id: null,
                    text: 'all_status',
                    label: this.$t('support_ticket_status.All'),
                    class: 'bg-gray-200'
                },
                {
                    id: SupportTicketStatus.OPEN,
                    text: 'open',
                    label: this.$t('support_ticket_status.Open'),
                    class: 'bg-green-200 text-green-800'
                },
                {
                    id: SupportTicketStatus.WAITING,
                    text: 'waiting',
                    label: this.$t('support_ticket_status.Waiting'),
                    class: 'bg-yellow-200 text-yellow-800'
                },
                {
                    id: SupportTicketStatus.CLOSED,
                    text: 'closed',
                    label: this.$t('support_ticket_status.Closed'),
                    class: 'bg-gray-200'
                },
                {
                    id: SupportTicketStatus.ARCHIVED,
                    text: 'archived',
                    label: this.$t('support_ticket_status.Archived'),
                    class: 'bg-gray-200'
                },
            ]
        }
    },
    methods: {
        /**
         * Handler select status
         */
        handleSelectStatus(status) {
            if (this.debug) console.debug("FilterStausBar@handleSelectStatus", {status})
            this.$emit('select', status?.id)
        }
    }
}
</script>